import { METRIC_SIGNALS } from './metricSignals';

export const MEDIUM_SAMPLE_RATE = 0.2;

export const COUNTER_ONLY_LABELS = new Set<string>([
  ...Array.from(METRIC_SIGNALS),
  'container_section_failed',
]);
